<template>
  <div class="ttshop_userindex">
    <div class="w">
      <div class="ttshop_userindexcon clearfloat">
        <div class="ttshop_usertitle clearfloat" @click="goTtshop_user">
          <i><img class="img-default" src="../../../assets/images/ttshop_user.png" /></i>
          <h4>个人中心</h4>
        </div>
        <div class="ttshop_userright clearfloat">
          <div class="ttshop_userindexs" @click="sendMsg">
            首页
          </div>
          <div class="ttshop_userxl">
            <div class="ttshop_userxltou">
              <el-dropdown @command="handleIndex">
                <div class="ttshop_userxltous clearfloat">
                  <strong class="el-dropdown-link">账户设置</strong>
                  <i><img class="img-default" src="../../../assets/images/ttshop_userxl.png" alt=""></i>
                </div>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item command="1">个人信息</el-dropdown-item>
                  <el-dropdown-item command="2">地址管理</el-dropdown-item>
                  <!-- <el-dropdown-item>账户安全</el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    sendMsg() {
      //func: 是父组件指定的传数据绑定的函数，this.msg:子组件给父组件传递的数据
      this.$router.push("/");
    },
    handleIndex(command) {
      //func: 是父组件指定的传数据绑定的函数，this.msg:子组件给父组件传递的数据
      console.log(command)
      if (command == 1) {
        this.$router.push("/ttshop_usernews");
      } else if(command == 2){
        this.$router.push("/ttshop_siterun");
      }
    },
    goTtshop_user(){
      this.$router.push("/ttshop_user");
    }
  },
};
</script>

<style lang="scss" scoped>
.ttshop_userindex {
  width: 100%;
  height: 68px;
  background: linear-gradient(90deg, #ff9010, #ff0e25);
  background: -moz-linear-gradient(90deg, #ff9010, #ff0e25);
  background: -webkit-gradient(90deg, #ff9010, #ff0e25);
  background: -ms-linear-gradient(90deg, #ff9010, #ff0e25);
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#FF9010, endColorstr=#FF0E25);

  .ttshop_userindexcon {
    width: 100%;
    height: 68px;

    .ttshop_usertitle {
      float: left;
      padding-top: 19px;
      box-sizing: border-box;
      margin-right: 88px;
      cursor: pointer;

      i {
        float: left;
        width: 31px;
        height: 30px;
        margin-right: 6px;

        img {
          display: block;
        }
      }

      h4 {
        float: left;
        font-size: 18px;
        color: #fff;
        font-weight: 500;
        line-height: 30px;
      }
    }

    .ttshop_userright {
      float: left;
      height: 68px;
      .ttshop_userindexs {
        float: left;
        // font-size: 14px;
        font-size: 16px;
        color: #fff;
        font-weight: 400;
        margin-right: 58px;
        cursor: pointer;
        padding-top: 25px;
        box-sizing: border-box;
      }

      .ttshop_userxl {
        float: left;

        .ttshop_userxltou {
          display: block;
          position: relative;
          height: 68px;
          padding-top: 25px;
          box-sizing: border-box;
          .ttshop_userxltous {
            display: block;
            cursor: pointer;
            strong {
              float: left;
              font-size: 14px;
              color: #fff;
              font-weight: 400;
              margin-right: 4px;
            }
            .el-dropdown-link{
              font-size: 16px;
            }
            i {
              float: left;
              width: 14px;
              height: 14px;
              margin-top: 4px;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;
              img {
                display: block;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
